import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { errorToast } from "@/shared/ui";
import {
  medicationRequestQueriesStore,
  updateMedicationRequestStatus,
} from "../api";

export const useUpdateMedicationStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMedicationRequestStatus,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: medicationRequestQueriesStore.medicationRequest._def,
      });
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
    },
    onError: errorToast,
  });
};
